// otp.thunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../api/api";
import { ActionTypes } from "../constants/action-types";

export const generateOtp = createAsyncThunk(
  ActionTypes.GENERATE_OTP,
  async ({ email, carrierCanonicalId }: { email: string; carrierCanonicalId: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall("otp-verification/generate", "post", {
        email,
        carrierCanonicalId
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const verifyOtp = createAsyncThunk(
  ActionTypes.VERIFY_OTP,
  async (
    { email, otp, carrierCanonicalId }: { email: string; otp: string; carrierCanonicalId: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall("otp-verification/verify", "post", {
        email,
        otp,
        carrierCanonicalId
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getConsumer = createAsyncThunk(
  ActionTypes.GET_CONSUMER,
  async ({canonicalId, carrierCanonicalId}:{canonicalId: string,carrierCanonicalId:string}, { rejectWithValue }) => {
    try {
      const res = await apiCall(`user/${canonicalId}`, "get",carrierCanonicalId);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const requestPasswordReset = createAsyncThunk(
  ActionTypes.REQUEST_PASSWORD_RESET,
  async (email: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `register-carrier/request-password-reset`,
        "post",
        { email }
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const verifyResetPasswordOtp = createAsyncThunk(
  ActionTypes.VERIFY_RESET_PASSWORD_OTP,
  async (
    { email, otp }: { email: string; otp: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`register-carrier/verify-reset-otp`, "post", {
        email,
        otp,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const resetPassword = createAsyncThunk(
  ActionTypes.RESET_PASSWORD,
  async (
    {
      email,
      otp,
      newPassword,
    }: {
      email: string;
      otp: string;
      newPassword: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`register-carrier/reset-password`, "post", {
        email,
        otp,
        newPassword,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
